import React from 'react';
import moment from 'moment';
import {Text, TextMessage} from 'components/tt-forms/common';
import { connect } from 'react-redux';
import {ContainerFileDinhKem} from 'components/upload';
import { ShowIf } from 'components/utils';
import { GiaiQuyetDonThu } from 'api';

class KetQuaHoanThanhGiaiQuyetDonCanBo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      donViThamTraXacMinhInfo: this.props.donViThamTraXacMinhInfo,
      ngayHetHanTTXM: this.props.ngayHetHanTTXM,
      dataKetQuaGiaiQuyetDon: []
    }
  }

  componentDidMount() {
    this.getKetQuaGiaiQuyetDon();
    if (window.debug) {
      console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/KetQuaHoanThanhGiaiQuyetDonCanBo');
    }
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      banHanhQuyetDinh: true,
      khongCoDoiThoai: false,
      loaiDon: this.props.loaiDon
    }
    GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaGiaiQuyetDon: res.data
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps});
  }

  render() {
    let ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(state => {
      return state.giaTri == this.props.ketLuanNoiDungKhieuNai
    });
    let ketQuaThucHien = this.props.dataKetQuaThucHien.filter(state =>{
      return state.giaTri == this.props.ketQuaThucHienTheoDoi
    })
    let ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(state => {
      return state.giaTri == this.props.ketQuaXLDGiaiQuyet
    })
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block container-filedinhkem">
        <h2 className="title-14 mb15 mt10">Báo cáo kết quả xác minh{lb2}</h2>
        <div className="row pl10 pr10">
          <div className="col-100">
            <div className="col-100 no-gutter">
              <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.props.giaHanGiaiQuyet}>
                <div className="col-100 no-gutter mt5 pb20">
                  <div className="row pl10 pr10">
                    <h2 className="title-12 mb15 pl5 pr5">Gia hạn giải quyết tố cáo</h2>
                    <Text className="col-25" label="Số quyết định gia hạn:" value={this.props.soQuyetDinhGiaHanGiaiQuyet}/>
                    <Text className="col-25" label="Ngày ra quyết định:" value={this.props.ngayRaQuyetDinhGiaHanGiaiQuyet ? moment(this.props.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                    <Text className="col-25" red={true} label="Gia hạn giải quyết đến ngày:" value={this.props.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.props.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                    <TextMessage className="col-100 mb0-18" label="Lý do gia hạn:" value={this.props.lyDoGiaHanGiaiQuyet}/>
                  </div>
                </div>
              </ShowIf>
            </div>
          </div>
        </div>
        <div className="row pl10 pr10">
          <div className="col-100">

            <ShowIf condition={ketQuaGiaiQuyetDon.length > 0}>
              <div className="col-100 mt5 no-gutter">
                <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
                <div className="row pl10 pr10">
                  <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
                  <Text className="col-25 mb10" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''}/>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.loaiDon == 'DON_KHIEU_NAI' && this.props.doiThoai}>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Đối thoại</h2>
                  <div className="row pl10 pr10">
                    <Text className="col-25 mb10" label="Thời gian đối thoại:" value={this.props.thoiGianDoiThoai ? moment(this.props.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                    <Text className="col-75 mb10" label="Địa điểm:" value={this.props.diaDiemDoiThoai}/>
                    <TextMessage className='col-100' label='Nội dung, kết quả đối thoại:'value={this.props.noiDungDoiThoai ? this.props.noiDungDoiThoai : ''}/>
                  </div>
                </div>
              </div>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.quyetDinhGiaiQuyetKhieuNai}>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter mt5 pb5">
                  <ShowIf condition={this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                    <div>
                      <ShowIf condition={this.props.loaiDon == 'DON_KHIEU_NAI'}><h2 className="title-12 mb15">Quyết định giải quyết khiếu nại</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO'}><h2 className="title-12 mb15">Quyết định giải quyết tố cáo</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI'}><h2 className="title-12 mb15">Văn bản giải quyết kiến nghị, phản ánh</h2></ShowIf>
                      <div className="row pl10 pr10 mb15">
                        <Text className="col-25 mb0-18" label="Số vụ:" value={String(this.props.soVuGiaiQuyetKhieuNai)}/>
                        <Text label="Kết luận nội dung khiếu nại:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
                        <Text label="Kết quả khác:" className="col-25" value={this.props.ketQuaGiaiQuyetKhac}/>
                      </div>
                      <div className="row pl10 pr10">
                        <div className="col-50 no-gutter mb20">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                          <Text className="col-50 mb0-18" label="Phải thu tiền (đ):" value={String(this.props.tienPhaiThuNhaNuocQDGQ)}/>
                          <Text className="col-50 mb0-18" label="Phải thu đất (m2):" value={String(this.props.datPhaiThuNhaNuocQDGQ)}/>
                        </div>
                        <div className="col-50 no-gutter mb20">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                          <Text className="col-50 mb0-18" label="Phải trả tiền (đ):" value={String(this.props.tienPhaiTraCongDanQDGQ)}/>
                          <Text className="col-50 mb0-18" label="Phải trả đất (m2):" value={String(this.props.datPhaiTraCongDanQDGQ)}/>
                        </div>
                        <div className="col-100 no-gutter">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                          <Text className="col-25 mb0-18" type="sdt" label="Tổng số người:" value={String(this.props.tongSoNguoiXuLyHanhChinh)}/>
                          <Text className="col-25 mb0-18" type="sdt" label="Số người đã bị xử lý:" value={String(this.props.soNguoiDaBiXuLyHanhChinh)}/>
                          <Text className="col-25 mb0-18" label="Số người được trả lại quyền lợi:" value={String(this.props.soNguoiDuocTraLaiQuyenLoi)}/>
                        </div>
                      </div>
                    </div>
                  </ShowIf>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.theoDoiThucHien}>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Theo dõi thực hiện</h2>
                  <div className="row pl10 pr10 mb15">
                    <Text className="col-25 mb0-18" label="Kết quả thực hiện:" value={ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : ''}/>
                    <Text className="col-25 mb0-18" label="Kết quả thực hiện khác:" value={this.props.ketQuaThucHienKhac}/>
                  </div>
                  <div className="row pl10 pr10">
                    <div className="col-100 no-gutter mb15">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                      <Text className="col-25 mb0-18" label="Phải thu tiền (đ):" value={String(this.props.tienPhaiThuNhaNuoc)}/>
                      <Text className="col-25 mb0-18" label="Phải thu đất (m2):" value={String(this.props.datPhaiThuNhaNuoc)}/>
                      <Text className="col-25 mb0-18" label="Đã thu tiền (đ):" value={String(this.props.tienDaThuNhaNuoc)}/>
                      <Text className="col-25 mb0-18" label="Đã thu đất (m2):" value={String(this.props.datDaThuNhaNuoc)}/>
                    </div>
                    <div className="col-100 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                      <Text className="col-25 mb0-18" label="Phải trả tiền (đ):" value={String(this.props.tienPhaiTraCongDan)}/>
                      <Text className="col-25 mb0-18" label="Phải trả đất (m2):" value={String(this.props.datPhaiTraCongDan)}/>
                      <Text className="col-25 mb0-18" label="Đã trả tiền (đ):" value={String(this.props.tienDaTraCongDan)}/>
                      <Text className="col-25 mb0-18" label="Đã trả đất (m2):" value={String(this.props.datDaTraCongDan)}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.giaoCoQuanDieuTra}>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                  <div className="row pl10 pr10">
                    <Text className="col-25 mb0-18" label="Tên cơ quan:" value={this.props.coQuanDieuTraInfo ? this.props.coQuanDieuTraInfo.ten : ''}/>
                    <Text className="col-25 mb0-18" label="Số vụ:" value={String(this.props.soVuGiaoCoQuanDieuTra)}/>
                    <Text className="col-25 mb0-18" label="Số đối tượng:" value={String(this.props.soDoiTuongGiaoCoQuanDieuTra)}/>
                  </div>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.khoiTo}>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Khởi tố</h2>
                  <div className="row pl10 pr10">
                    <div className="col-50 no-gutter">
                      <Text className="col-50 mb0-18" label="Số vụ:" value={String(this.props.soVuBiKhoiTo)}/>
                      <Text className="col-50 mb0-18" label="Số đối tượng:" value={String(this.props.soDoiTuongBiKhoiTo)}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>

          </div>
          <div className="col-100 pb5">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true} hideDescription={true}/>
          </div>

          <ShowIf condition={!this.props.boSungThongTin && (this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(this.props.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="DSVanBanBS" label="Danh sách văn bản bổ sung" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

KetQuaHoanThanhGiaiQuyetDonCanBo.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(KetQuaHoanThanhGiaiQuyetDonCanBo);


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/KetQuaHoanThanhGiaiQuyetDonCanBo.jsx